import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Observable, combineLatest, map, take, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectPermissions } from '../permissions/permission.selector';
import { setPermissions } from '../permissions/permission.action';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private store: Store,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.auth.isLoggedIn().pipe(
      map(() => {
        const authToken = localStorage.getItem('AUTH_TOKEN');
        const isLoggedIn = !!authToken;
  
        if (!isLoggedIn) {
          console.log('User is not logged in');
          return false;
        }
  
        const rolesAndPermissionRaw = localStorage.getItem('rolesAndPermision');
        const rolesPermission = rolesAndPermissionRaw ? JSON.parse(rolesAndPermissionRaw) : [];
        console.log('rolesPermission', rolesPermission);
     

        const allowedRoles = route.data['allowedRoles'] as
        | { moduleId: number; permissionIds?: number[]; permissionKeys?: string[] }
        | undefined;
      
      if (allowedRoles) {
        const hasPermission = rolesPermission.some((role: any) => {
          const moduleMatch = Number(role.moduleId) === Number(allowedRoles.moduleId);
          if (!moduleMatch) return false;
      
          const rolePermissions = role.permissions || [];
      
          if (allowedRoles.permissionIds?.length) {
            // fallback: numeric IDs
            return rolePermissions.some((p: any) =>
              allowedRoles.permissionIds!.includes(p.permissionId)
            );
          }
      
          if (allowedRoles.permissionKeys?.length) {
            // new: check by description
            return rolePermissions.some((p: any) =>
              allowedRoles.permissionKeys!.includes(p.description)
            );
          }


          this.store.dispatch(setPermissions({ permissions: rolePermissions }));

          return rolePermissions.length > 0; // module access if any perms exist
        });
      
        if (!hasPermission) {
          this.router.navigate(['/page-not-found']);
          return false;
        }
      }
      
        return true; // Logged in and has permission
      }),
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          console.log('Not authenticated. Clearing storage and redirecting to login.');
          localStorage.removeItem('AUTH_TOKEN');
          localStorage.removeItem('loggedInUser');
          sessionStorage.removeItem('AUTH_TOKEN');
          this.router.navigate(['/login']);
        }
      })
    );
  }
  
  
}